<script>
import request from '@/libs/request'
import {
  BCard, BFormGroup, BFormInput, BCardBody, BForm, BButton, BRow, BCol
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BCardBody,
    BForm,
    BButton,
    BRow,
    BCol
  },
  data () {
    return {
      zoneData: {
        uuid: this.$route.params.uuid,
        name: ''
      }
    }
  },
  created () {
    this.fetchZone()
  },
  methods: {
    onSubmit () {
      request({
        url: 'zones/' + this.zoneData.uuid,
        method: 'PUT',
        params: { name: this.zoneData.name }
      }).then(() => this.$router.push('/zones')).catch(() => console.log('Hubo un error al registrar la nueva zona'))
    },
    fetchZone () {
      return request({
        url: `zones/${this.zoneData.uuid}`,
        method: 'GET'
      }).then(data => { this.zoneData.name = data.data.name })
    }
  }
}
</script>
<template>
    <div>
        <b-card title="Editar zona">
            <b-card-body style="max-width: 50rem;">
              <b-form @submit.prevent="onSubmit">
                <b-row>
                  <b-col sm="12" md="6">
                    <b-form-group label="Nombre de zona">
                        <b-form-input maxlength="50" required v-model="zoneData.name"/>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="mt-4">
                  <b-col>
                    <b-button class="mr-1" variant="secondary" @click="$router.push('/zones')" type="button">Volver</b-button>
                    <b-button variant="primary" type="submit">Guardar</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
        </b-card>
    </div>
</template>
